import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import ApiSettings from './pages/ApiSettings';
import Settings from './pages/Settings';
import Testing from './pages/Testing';
import SalesAssistant from './pages/SalesAssistant';
import JobGrids from './pages/JobGrids';
import JobGridsSettings from './pages/JobGridsSettings';
import McodeTranslation from './pages/McodeTranslation';
import McodeTranslationSettings from './pages/McodeTranslationSettings';
import CaseStudies from './pages/CaseStudies';
import CaseStudiesSettings from './pages/CaseStudiesSettings';
import Layout from './components/Layout';
import ProtectedRoute from './components/ProtectedRoute';
import { AuthProvider } from './contexts/AuthContext';
import { migrateExistingData } from './utils/projectStorage';
import './App.css';

function App() {
  useEffect(() => {
    // Migrate existing data to new structure on app load
    migrateExistingData();
  }, []);

  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          
          {/* Main app routes */}
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <Layout />
              </ProtectedRoute>
            }
          >
            <Route index element={<Navigate to="/project/sales-assistant" replace />} />
            <Route path="api-settings" element={<ApiSettings />} />
            
            {/* Project Main Views */}
            <Route path="project/sales-assistant" element={<SalesAssistant />} />
            <Route path="project/job-grids" element={<JobGrids />} />
            <Route path="project/mcode-translation" element={<McodeTranslation />} />
            <Route path="project/case-studies" element={<CaseStudies />} />
            
            {/* Settings (accessible via admin panel) */}
            <Route path="project/sales-assistant/settings" element={<Settings />} />
            <Route path="project/job-grids/settings" element={<JobGridsSettings />} />
            <Route path="project/mcode-translation/settings" element={<McodeTranslationSettings />} />
            <Route path="project/case-studies/settings" element={<CaseStudiesSettings />} />
            
            {/* Testing (accessible via admin panel) */}
            <Route path="project/sales-assistant/testing" element={<Testing />} />
            <Route path="project/job-grids/testing" element={<Testing />} />
            <Route path="project/mcode-translation/testing" element={<Testing />} />
            <Route path="project/case-studies/testing" element={<Testing />} />
          </Route>
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
